import type { EntityImportField } from './types';

function normalizeHeader(value: string): string {
  return value.trim().toLowerCase().replace(/[_\-]+/g, ' ').replace(/\s+/g, ' ');
}

/**
 * Auto-map target fieldnames to detected file headers using aliases.
 * Returns Record<fieldname, headerColumn>.
 */
export function autoMapHeaders(
  headers: string[],
  fields: EntityImportField[],
  headerAliases: Record<string, string[]>
): Record<string, string> {
  const normalizedHeaders = headers.map((h) => ({ raw: h, key: normalizeHeader(h) }));
  const used = new Set<string>();
  const mapping: Record<string, string> = {};

  for (const field of fields) {
    const aliases = [
      field.fieldname,
      field.label,
      ...(headerAliases[field.fieldname] || []),
    ].map(normalizeHeader);

    const match = normalizedHeaders.find(
      (h) => !used.has(h.raw) && aliases.includes(h.key)
    );
    if (match) {
      mapping[field.fieldname] = match.raw;
      used.add(match.raw);
    }
  }

  return mapping;
}

export function applyColumnMapping(
  rows: Record<string, string>[],
  mapping: Record<string, string>
): Record<string, string>[] {
  return rows.map((row) => {
    const mapped: Record<string, string> = {};
    for (const [fieldname, sourceCol] of Object.entries(mapping)) {
      if (!sourceCol) continue;
      mapped[fieldname] = (row[sourceCol] || '').trim();
    }
    return mapped;
  });
}
